//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionLock(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M17 8V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H4V18H6V10H18V20H4V22H20V8H17ZM15 8H9V6C9 4.35 10.35 3 12 3C13.65 3 15 4.35 15 6V8Z" fill="currentColor" /><path d="M12 17.25C13.2426 17.25 14.25 16.2426 14.25 15C14.25 13.7574 13.2426 12.75 12 12.75C10.7574 12.75 9.75 13.7574 9.75 15C9.75 16.2426 10.7574 17.25 12 17.25Z" fill="currentColor" /></svg>;
}
export default IconActionLock;